<template>
  <div id="salesSkuYearDetail">
    <div style="background-color: #fff; padding: 0 10px; ">
      <el-button
        @click="$router.go(-1)"
        style="color: #ff9901"
        icon="el-icon-arrow-left"
        type="text"
        >返回</el-button
      >
    </div>
    <div class="skuDe">
      <p style="color: #4d586d">{{ SkuDetail.sku_name || "暂无" }}</p>
      <p style="color: #b0b5b9; font-size: 12px; margin-top: 6px">
        规格:{{ SkuDetail.specification || "暂无" }}
      </p>
      <p style="color: #b0b5b9; font-size: 12px; margin-top: 6px">
        生产厂家:{{ SkuDetail.manufacturer || "暂无" }}
      </p>
      <p style="color: #7ed321; font-size: 14px; margin-top: 10px">
        包装单位:{{ SkuDetail.unit_name || "暂无" }}
      </p>
    </div>
    <m-ym
      :value="year"
      @change="changeYM"
      format="YYYY"
      style=" padding: 10px 10px"
    ></m-ym>
    <!-- 门店 -->
    <div class="swiper-container" id="swiperSKUSales">
      <div class="swiper-wrapper">
        <div
          @click="selectItem(item.store_id)"
          v-for="item in list"
          ref="storeItem"
          :key="item.store_id"
          :class="{
            item: true,
            itemSelect: storeSelect === item.store_id,
            'swiper-slide': true,
          }"
        >
          <div style="color: #4d586d">
            <span>{{ item.store_name }}</span>
          </div>
          <div style="color: #b0b5b9; font-size: 14px; margin-top: 8px">
            <span>{{ item.address || "" }}</span>
          </div>
          <div
            class="shuxian"
            style="margin-top: 11px; font-size: 14px; color: #7ed321"
          >
            <span>店员总数：{{ item.clerk_num || 0 }}人</span>
          </div>
        </div>
      </div>
      <div class="swiper-scrollbar"></div>
    </div>
    <!--  -->
    <div ref="tableBox" style="overflow: hidden">
      <el-table
        :data="tableData"
        style="width: 100%; background: #f5f7fa"
        :header-cell-style="headerCellStyle"
        @sort-change="sortChange"
        :cell-style="CellStyle"
      >
        <el-table-column prop="month" label="月份">
          <template slot-scope="scope">
            <div>
              <span
                style="
                  color: #fff;
                  padding: 3px 5px;
                  background: #ff9901;
                  font-size: 12px;
                  border-radius: 4px;
                "
                >{{ scope.row.month || "-" }}</span
              >
            </div>
          </template>
        </el-table-column>

        <el-table-column
          prop="target_quantity"
          label="指标"
          sortable="custom"
          width="90"
        >
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.target_quantity || "-" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="actual_quantity"
          label="实际"
          sortable="custom"
          width="90"
        >
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.actual_quantity || "-" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="rate"
          label="达成率"
          sortable="custom"
          width="100"
        >
          <template slot-scope="scope">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <span>{{ scope.row.rate || "-" }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";
import Swiper from "swiper";
import http from "../../APIService/http";
import moment from "moment";
import mYm from "./components/YMselect";
import { mapState } from "vuex";

export default {
  name: "salesSkuYearDetail",
  data() {
    return {
      storeSelect: this.$route.query.store_id,
      SkuDetail: {
        sku_name: "",
        specification: "",
        manufacturer: "",
        unit_name: "",
      },
      year: moment().format("YYYY"),
      list: [],
      monthData: [],
      tableData: [],
    };
  },
  components: {
    mYm,
  },
  watch: {
    storeSelect(val, old) {
      if (val !== old) {
        this.changeStore(val);
      }
    },
  },
  computed: {
    query() {
      return this.$store.getters.getDataQuery;
    },
    sku_id() {
      return this.$store.getters.getSalesSkuId;
    },
    territoryArr() {
      return this.$store.getters.getTerritoryArr;
    },
  },
  created() {
    this.getSkuDetail();
    this.SalesSkuYearDetail();
  },
  mounted() {},
  methods: {
    initSwiper() {
      this.$nextTick(() => {
        this.mySwiper = new Swiper("#swiperSKUSales", {
          slidesPerView: "auto",
          freeMode: true,
          scrollbar: {
            el: ".swiper-scrollbar",
            hide: true,
            mousewheel: true,
            draggable: true,
            snapOnRelease: false,
          },
        });
      });
    },
    setTableHeight() {
      this.$nextTick(() => {
        this.tableheight = parseFloat(
          window.getComputedStyle(this.$refs.tableBox).height
        );
      });
    },
    selectItem(val) {
      this.storeSelect = val;
    },
    changeYM(val) {
      this.year = val;
      this.SalesSkuYearDetail();
    },
    changeStore(store_id) {
      this.tableData = this.monthData[store_id];
    },
    SalesSkuYearDetail() {
      let forms = {
        tenant_id: this.query.tenant_id,
        user_id: this.query.user_id,
        territoryIds: [...this.territoryArr],
        year: this.year || moment().format("YYYY"),
        sku_id: this.sku_id,
      };
      http
        .post("b2b_sever/gkGetFeedback/SalesSkuYearDetail", forms)
        .then((res) => {
          this.list = res.data.stores;
          this.monthData = res.data.datas;
          this.changeStore(this.storeSelect);
          this.initSwiper();
        });
    },
    getSkuDetail() {
      let forms = {
        tenant_id: this.query.tenant_id,
        sku_id: this.sku_id,
      };
      http.post("b2b_sever/gkGetFeedback/getSkuDetail", forms).then((res) => {
        this.SkuDetail = res.data;
        this.setTableHeight();
      });
    },
    sortChange({ column, prop, order }) {
      if (order === "ascending") {
        this.tableData = this.tableData.sort((a, b) => {
          let v1 = new RegExp("[0-9]").test(a[prop])
            ? parseFloat(a[prop])
            : a[prop];
          let v2 = new RegExp("[0-9]").test(b[prop])
            ? parseFloat(b[prop])
            : b[prop];
          return v2 - v1;
        });
      } else {
        this.tableData = this.tableData.sort((a, b) => {
          let v1 = new RegExp("[0-9]").test(a[prop])
            ? parseFloat(a[prop])
            : a[prop];
          let v2 = new RegExp("[0-9]").test(b[prop])
            ? parseFloat(b[prop])
            : b[prop];
          return v1 - v2;
        });
      }
    },

    headerCellStyle() {
      return {
        "padding-top": "0",
        "padding-bottom": "0",
        "background-color": "#e0e0e0",
        color: "#5C575E",
      };
    },
    CellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label == "产品") {
        return {
          "padding-top": "8px",
          "padding-bottom": "8px",
          color: "#87909A",
        };
      } else if (column.label == "达成率") {
        return {
          "padding-top": "8px",
          "padding-bottom": "8px",
          color: parseFloat(row.rate) >= 100 ? "#7ED321" : "#ED3B3F",
        };
      } else {
        return {
          "padding-top": "8px",
          "padding-bottom": "8px",
          color: "#4A4A4A",
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#swiperSKUSales {
  padding: 10px 15px;
  background: #fff;
}
#salesSkuYearDetail .skuDe {
  background: #fff;
  flex-shrink: 0;
  padding: 15px 10px 10px 10px;
}
#salesSkuYearDetail .skuDe p {
  margin: 0;
}

.item {
  height: 86px;
  width: auto;
  padding: 10px;
  box-sizing: border-box;
  background: rgba(74, 144, 226, 0.1);
  margin-right: 10px;
  border: 1px solid #fff;
}
.item:last-child {
  margin-right: 0;
}
.itemSelect {
  border: 1px solid #4a90e2;
}

#salesSkuYearDetail {
  background: #f5f7fa;
}
.dateSelect {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}
.dateSelect > img {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesdata/salesSkuYearDetail.vue